<!--  -->
<template>
  <div class='update-page'>
    <nav-title title="账号登录">
      <template v-slot:left>
        <span></span>
      </template>
    </nav-title>
    <main>
      <p>不懂电镜商品管理系统</p>
      <div>
        <van-form @submit="handleAffirm" ref="form">
          <main class="form-item">
            <span class="form-title"><span>*</span>账号：</span>
            <div>
              <van-field
                name="admin_acc"
                clearable
                v-model="dataForm.admin_acc"
                placeholder="请输入账号 "
                type="text"
                :rules="[
                  {required: true},
                ]"
              />
            </div>
          </main>
          <main class="form-item">
            <span class="form-title"><span>*</span>密码：</span>
            <div>
              <van-field
                name="password"
                clearable
                :type="show ? 'text' : 'password'"
                show-password
                v-model="dataForm.password"
                placeholder="请输入密码"
                :rules="[
                  {required: true},
                ]">
                <template v-slot:right-icon>
                  <van-icon size="22" :name="show ? 'eye-o' : 'closed-eye'" @click="show = !show"/>
                </template>
              </van-field>
            </div>
          </main>
        </van-form>
      </div>
      <footer class="footer-btn-red" @click="$refs.form.submit()">登录</footer>
    </main>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      show: false,
      dataForm: {
        admin_acc: '',
        password: '',
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  //方法集合
  methods: {
    handleAffirm () {
      let form = Object.assign({
        c: 'login/admin/acc'
      }, this.dataForm)
      this.$http({
        method: 'post',
        data: form
      }).then(res => {
        if (res.code == 200) {
          this.$toast({
            message: '登录成功',
            className: 'set-toast'
          })
          window.localStorage.setItem('token', res.data.token)
          this.$router.push('/')
        } else {
          this.$toast.fail(res.message || '操作失败')
        }
      })
    }
  },
}
</script>

<style lang='less' scoped>
.update-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  > main {
    flex: 1;
    padding: 15px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    > p {
      font-size: 20px;
      color: #E73F22;
      text-align: center;
      margin-bottom: 20px;
      font-weight: bold;
      letter-spacing: 5px;
    }
    > div {
      flex: 1;
      margin-top: 20px;
      .form-item {
        width: 100%;
        margin-bottom: 20px;
        .form-title {
          font-size: 16px;
          display: block;
          margin-bottom: 10px;  
          > span {
            color: #E73F22;
          }
        }
        > div {
          flex: 1;
          height: 40px;
          display: flex;
          align-items: center;
          background-color: #fff;
          padding: 0px 15px;
          border-radius: 20px;
          box-shadow: 0px 2px 5px 1px #f0f0f0;
          .van-cell  {
            overflow: visible;
            /deep/ .van-field__error-message {
              position: absolute;
              top: 100%;
              left: 0;
            }
          }
        }
      }
    }
  }
}
</style>